import { render, staticRenderFns } from "./estudiantes.vue?vue&type=template&id=6184c6d4"
import script from "./estudiantes.vue?vue&type=script&lang=js"
export * from "./estudiantes.vue?vue&type=script&lang=js"
import style0 from "./estudiantes.vue?vue&type=style&index=0&id=6184c6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports